import { IconProps } from "../interface";
import { IconColours } from "../interface";

const ImageIcon = ({
    title = "image",
    type,
    size,
    className,
    colour = IconColours.black,
    secondaryColour = IconColours.white,
}: IconProps) => {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 -960 960 960"
            role="img"
        >
            <title>{title}</title>
            {type === "outlined" ? (
                <circle cx="480" cy="-480" r="480" fill={secondaryColour} />
            ) : null}
            <path
                data-testid="path"
                fill={colour}
                d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0 0v-560 560Zm80-80h400q12 0 18-11t-2-21L586-459q-6-8-16-8t-16 8L450-320l-74-99q-6-8-16-8t-16 8l-80 107q-8 10-2 21t18 11Z"
            />
        </svg>
    );
};

export default ImageIcon;
